
/*
 * Cherry Picked Kicks
 * Spotlight desktop mega-menu hover
 * Mobile navigation is untouched.
 */
(() => {
  const desktop = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  function initialise() {
    document.querySelectorAll(
      '.header__inline-menu header-menu > details.mega-menu'
    ).forEach((details) => {
      if (details.dataset.cpkHoverReady === 'true') return;
      details.dataset.cpkHoverReady = 'true';

      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      let closeTimer;

      function closeMenu() {
        clearTimeout(closeTimer);
        if (!details.open) return;

        const component = details.closest('header-menu');

        if (component && typeof component.close === 'function') {
          component.close();
        } else {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }
      }

      function openMenu() {
        if (!desktop.matches) return;

        clearTimeout(closeTimer);

        document.querySelectorAll(
          '.header__inline-menu header-menu > details.mega-menu'
        ).forEach((other) => {
          if (other !== details && other.open) {
            const component = other.closest('header-menu');
            if (component && typeof component.close === 'function') {
              component.close();
            } else {
              other.open = false;
            }
          }
        });

        if (!details.open) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }
      }

      details.addEventListener('mouseenter', openMenu);

      details.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;

        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (
            !details.matches(':hover') &&
            !details.contains(document.activeElement)
          ) {
            closeMenu();
          }
        }, 180);
      });

      details.addEventListener('focusin', () => {
        clearTimeout(closeTimer);
      });

      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) {
          closeMenu();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('shopify:section:load', initialise);

  if (document.readyState !== 'loading') initialise();
})();
